import React, {useContext} from "react";
import IdentificationFileUpload from "../IdentificationFileUpload";
import IdentificationContext from "../../../context/IdentificationContext";
import {UploadedFile} from "../../../../api-client";
import {CombinedDataContext} from "../../../../hooks/identification/useCombinedData";

const FirstScanUpload = () => {
  const context: CombinedDataContext = useContext(IdentificationContext);

  const loadFiles = (files: Array<UploadedFile>) => {
    context.setFirstPassportScans(files);
  };

  return (
    <IdentificationFileUpload
      prefix="first"
      text="Разворот с фотографией"
      files={context.firstPassportScans}
      onUploaded={loadFiles}
    />
  );
};

export default FirstScanUpload;